module.exports = __webpack_public_path__ + "static/img/wisdomApply2.a0a61be6.png";